import {metaParams} from '@/core/models/common/MetaParams';

export function useLayoutHead() {
    function getMetaParamsForPage(page, chapter) {
        if (metaParams.has(`${page}-${chapter}`)) {
            return metaParams.get(`${page}-${chapter}`);
        }

        return metaParams.get(page === '' ? 'main' : page) ?? [];
    }

    function getHeadMetaForPage(path = '') {
        const headObject = {
            link: [
                {
                    rel: 'canonical',
                    href: `https://www.centrinvest.ru${path.endsWith('/') ? path.slice(0, -1) : path}`,
                },
            ],
        };

        const splittedPath = path.split('/').filter(Boolean);
        const [chapter] = splittedPath;
        const pageName = splittedPath[splittedPath.length - 1];
        const [title, description, keywords] = getMetaParamsForPage(pageName, chapter);

        if (title) {
            headObject.title = title;
        }

        const meta = [];

        if (description) {
            meta.push({hid: 'description', name: 'description', content: description});
        }

        if (keywords) {
            meta.push({hid: 'keywords', name: 'keywords', content: keywords});
        }

        if (meta.length) {
            headObject.meta = meta;
        }

        return headObject;
    }

    return {
        getMetaParamsForPage,
        getHeadMetaForPage,
    };
};
